/* eslint-disable @typescript-eslint/no-explicit-any */
import { Row, Skeleton } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useParams } from 'react-router-dom';
import swal from 'sweetalert';
import axiosInstance from '../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfPlanContext,
  SkillListContext,
  UserPlanDataContext,
} from '../../../../../../context';
import { reorder } from '../../../../../../utils/helper';
import styles from '../styles.module.scss';
import PlanUploadModal from './add-plan';
import PlanDetail from './plan-detail-view';

const PlanCard: React.FC<any> = (): JSX.Element => {
  const [userPlanData, setUserPlanData] = useState<any>([]);
  const [skillList, setSkillList] = useState<any>();
  const [addNew, setAddNew] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [message, setMessage] = useState<string>();
  const { employeeId } = useParams();
  const { numberOfPlans, setNumberOfPlans } = useContext(NumberOfPlanContext);

  useEffect(() => {
    axiosInstance.get('/api/v1/skills').then((response) => {
      const allSkills = response.data.skills;
      const skills = allSkills.reduce(
        // eslint-disable-next-line @typescript-eslint/ban-types
        (initialList: Object, CurrentList: { [key: string]: any }) => ({
          ...initialList,
          [CurrentList.skill_name]: CurrentList.skill_id,
        }),
        {}
      );
      setSkillList(skills);
    });
  }, []);

  useEffect(() => {
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/profile/admin/user-profiles/' + employeeId + '/plans';
    } else {
      url = '/api/v1/profile/user-profiles/plans';
    }
    axiosInstance
      .get(url)
      .then((response) => {
        const orderedPlans = response.data.order
          .map((planId: number) =>
            response.data.plans.find((plan: any) => plan.id === planId)
          )
          .filter((item: any) => item !== undefined);
        setNumberOfPlans(orderedPlans.length);
        setUserPlanData(orderedPlans);
      })
      .catch((error) => {
        setMessage("Something went wrong!Items couldn't be loaded!");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    if (userPlanData.length < 2) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }

    const items = reorder(
      userPlanData,
      result.source.index,
      result.destination.index
    );
    const order_list = items.map((item: any) => item.id);
    setUserPlanData(items);

    const payload: any = {
      type: 'plans',
      updated_reorder_list: order_list,
    };
    if (isAdmin === '1') {
      payload.profile_id = employeeId;
    }

    axiosInstance
      .post('/api/v1/reorder', payload)
      .then((response) => {
        swal({
          title: 'Updated',
          text: 'Order of plans has been updated',
          icon: 'success',
        }).then((willRefresh) => {
          console.log();
        });
      })
      .catch((error) => {
        swal({
          title: 'Failed',
          text: 'Order of plans could not be updated',
          icon: 'error',
        }).then((willRefresh) => {
          console.log();
        });
      });
  };

  return (
    <div style={{ position: 'relative' }}>
      <UserPlanDataContext.Provider value={{ userPlanData, setUserPlanData }}>
        <SkillListContext.Provider value={{ ...skillList }}>
          {isLoading ? (
            <Skeleton active />
          ) : (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided: any, snapshot: any) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {userPlanData.map((item: any, index: any) => (
                      <Draggable
                        key={`row_${item.id}`}
                        draggableId={`row_${item.id}`}
                        index={index}
                      >
                        {(provided: any, snapshot: any) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <PlanDetail key={index} {...item} />
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}
          {message ? <p style={{ color: 'red' }}>{message}</p> : <></>}
          <Row style={{ position: 'relative' }}>
            <p
              className={styles['add-new']}
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              onClick={(e) => {
                setAddNew(true);
              }}
            >
              Make Plan (+)
            </p>
          </Row>
          <PlanUploadModal
            {...{ isModalOpen: addNew, setIsModalOpen: setAddNew }}
          />
        </SkillListContext.Provider>
      </UserPlanDataContext.Provider>
    </div>
  );
};

export default PlanCard;
